export default "__VITE_PUBLIC_ASSET__5ddc0207__"